/**
 * ═══ LE CODE COURT D'UN ÉCRAN DE SALLE ═══
 *
 * Le poste du vidéoprojecteur n'est connecté à rien : ni messagerie ni courriel où coller
 * une adresse. On y tapait donc le lien de l'écran en entier, jeton de trente-deux
 * caractères compris. L'événement a maintenant UN code de huit caractères, que la
 * régie montre à tout moment (`ScreenCodeManager.tsx`) ; sur le poste, on ouvre `/ecran`
 * et on le tape (`api/src/helpers/screenCode.js`, dont ce fichier reprend l'alphabet).
 *
 * ⚠️ UN ALPHABET SANS SOSIE : ni O/0, ni I/1/L. Le code se dicte dans une salle bruyante
 * et se tape sur un clavier qu'on ne connaît pas.
 */
export const PAIR_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
export const PAIR_LENGTH = 8;

/** L'adresse courte à ouvrir sur le poste, la même pour tous les événements. */
export const PAIR_PATH = "/ecran";

/** Ce qu'on a tapé, ramené à la forme du code : majuscules, sans espaces ni tirets. */
export function normalizePairCode(input: string): string {
  return input.toUpperCase().replace(/[\s\-._]/g, "");
}

export function isPairCode(code: string): boolean {
  return code.length === PAIR_LENGTH && [...code].every((c) => PAIR_ALPHABET.includes(c));
}

/** Ce qu'on tape, montré par groupes de quatre à mesure qu'on le tape : `K7P4-QX`. */
export function typedPairCode(input: string): string {
  const code = normalizePairCode(input).slice(0, PAIR_LENGTH);
  return code.length > 4 ? `${code.slice(0, 4)}-${code.slice(4)}` : code;
}

/**
 * CE QUI NE VA PAS DANS LE CODE TAPÉ, dit à la personne devant le poste — ou `null`.
 *
 * ⚠️ LES SOSIES D'ABORD : quelqu'un qui lit « O » sur l'écran de la régie le tapera. Le
 * lui dire vaut mieux que « code invalide ».
 */
export function pairCodeProblem(code: string): string | null {
  if ([...code].some((c) => "O0I1L".includes(c))) {
    return "Le code ne contient ni O, ni 0, ni I, ni 1, ni L : vérifiez-le sur l'écran de la régie.";
  }
  if (code.length !== PAIR_LENGTH) return `Le code fait ${PAIR_LENGTH} caractères.`;
  if (!isPairCode(code)) return "Le code ne contient que des lettres et des chiffres.";
  return null;
}
